import { buildIdentifierInput } from "@repo/components/src/forms/identifier/logic";
import {
  TaxProfileFieldKeyEnum,
  type TaxProfileAddressInputType,
  type TaxProfileInputType,
} from "@repo/graphql/gql/graphql";
import type { TaxProfileFieldData, TaxProfileFormValues } from "./types";

/**
 * The mutation input for the active form. Only the fields the form includes
 * are sent: an omitted boolean or address leaves the stored one unchanged,
 * while an omitted text field (giro, email) is cleared by the backend, so a
 * value typed under a previous regime is never kept.
 */
export const buildTaxProfileInput = (
  fields: ReadonlyArray<TaxProfileFieldData>,
  values: TaxProfileFormValues,
  addressInput: TaxProfileAddressInputType | undefined,
): TaxProfileInputType => {
  const input: TaxProfileInputType = {
    taxIdInput: buildIdentifierInput(values.taxId),
    legalName: values.legalName,
  };
  for (const field of fields) {
    switch (field.key) {
      case TaxProfileFieldKeyEnum.TaxId:
      case TaxProfileFieldKeyEnum.LegalName:
        break;
      case TaxProfileFieldKeyEnum.TaxRegime:
        input.taxRegime = values.taxRegime;
        break;
      case TaxProfileFieldKeyEnum.BusinessActivity:
        input.businessActivity = values.businessActivity || undefined;
        break;
      case TaxProfileFieldKeyEnum.Email:
        input.email = values.email || undefined;
        break;
      case TaxProfileFieldKeyEnum.AddressLine:
        input.address = values.addressLine || undefined;
        break;
      case TaxProfileFieldKeyEnum.Address:
        input.addressInput = addressInput;
        break;
      case TaxProfileFieldKeyEnum.IsLargeTaxpayer:
        input.isLargeTaxpayer = values.isLargeTaxpayer;
        break;
      case TaxProfileFieldKeyEnum.IsMunicipalWithholdingAgent:
        input.isMunicipalWithholdingAgent = values.isMunicipalWithholdingAgent;
        break;
    }
  }
  return input;
};
